import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ea0acec"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["^open"]
const _hoisted_2 = { class: "region-picker-popup" }
const _hoisted_3 = { class: "region-picker-popup__heading" }
const _hoisted_4 = {
  class: "region-picker-popup__copy",
  "data-test-id": "popup-copy"
}
const _hoisted_5 = {
  class: "region-picker-popup__label",
  "data-test-id": "popup-label"
}
const _hoisted_6 = { class: "region-picker-popup__input" }
const _hoisted_7 = ["^success"]
const _hoisted_8 = {
  for: "postCodeInput",
  "data-test-id": "control-input-label"
}
const _hoisted_9 = ["^maxlength"]
const _hoisted_10 = {
  key: 0,
  id: "errorPlaceholder",
  "data-test-id": "control-error"
}
const _hoisted_11 = {
  mode: "primary",
  class: "region-picker-popup__nba"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("owc-header-secondary-flyout", {
    "^name": 'region-picker-flyout',
    "is-left-aligned": true,
    "^open": _ctx.isVisible
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        id: "app",
        novalidate: "true",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)), ["prevent"]))
      }, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('emh.regionPicker.heading')), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('emh.regionPicker.copy')), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('emh.regionPicker.label')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("wb-input-control", { "^success": _ctx.success }, [
            _createElementVNode("wb-input", null, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('emh.regionPicker.placeholder')), 1),
              _withDirectives(_createElementVNode("input", {
                id: "postCodeInput",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRegion) = $event)),
                "aria-labelledby": "errorPlaceholder",
                "^maxlength": _ctx.digitAmount,
                pattern: "",
                type: "text",
                "data-test-id": "control-input",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetValidationState && _ctx.resetValidationState(...args)))
              }, null, 40, _hoisted_9), [
                [_vModelText, _ctx.selectedRegion]
              ])
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("wb-control-error", _hoisted_10, _toDisplayString(_ctx.$t('emh.regionPicker.error')), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_7)
        ]),
        _createElementVNode("wb-button-control", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: "region-picker-popup__submit-button wb-button wb-button--primary",
            "data-test-id": "btn-submit",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
          }, _toDisplayString(_ctx.$t('emh.regionPicker.submit')), 1),
          (!_ctx.isRequired)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "region-picker-popup__close-button wb-button wb-button--secondary wb-button--large",
                "data-test-id": "btn-close",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetAndClose && _ctx.resetAndClose(...args)))
              }, _toDisplayString(_ctx.$t('emh.regionPicker.close')), 1))
            : _createCommentVNode("", true)
        ])
      ], 32)
    ])
  ], 8, _hoisted_1))
}